<template>
    <div class="activity_container">
        <headerWX class="headerWX"></headerWX>

        <div class="main_content">
            <div class="light_pool_section pubile">
                <div class="tit">
                    <div class="lift">
                        <img src="@/assets/imgs/OpeningCeremony/btn_rule.png" alt=""
                            @click="openModal('rule', '活动规则', OpeningCeremonyData.content)" />
                        <img src="@/assets/imgs/OpeningCeremony/btn_Record.png" alt=""
                            @click="openModal('Record', '抽奖记录', null)" />
                    </div>
                    <img class="tit_bg" src="@/assets/imgs/OpeningCeremony/title_light_pool.png" alt="" />
                    <div class="right">
                        <img src="@/assets/imgs/OpeningCeremony/title_currency_bg.png" alt="" />
                        <div class="coin">
                            <!-- <p class="coin_num">白金币：{{ getActivityList.drawTokenBalance }}</p> -->
                            <p class="coin_num">白金币：{{ UserInfo.wallteInfo?.chargeMoney }}</p>
                            <!-- <p class="coin_exchange" @click="openExchange">兑换</p> -->
                        </div>
                    </div>
                </div>
                <!-- 点亮 -->
                <div class="pool_grid_wrapper">
                    <div class="wrapper_Content">
                        <div class="wrapper_Content_item" v-for="value in 25" :key="value">
                            <img v-if="OpeningCeremonyData?.lightedGrids?.includes(value - 1)"
                                src="@/assets/imgs/OpeningCeremony/grid_blue.png" alt="" />
                            <img v-else src="@/assets/imgs/OpeningCeremony/grid_silver.png" alt="" />
                        </div>
                        <div class="right_Reward">
                            <div class="right_Reward_item Reward_item" v-for="value in getLinesByPosition('Lift')"
                                :key="value.lineCode" @click="receiveAwardFun(value)"
                                :class="{ 'is-waiting': value.status == 1, 'is-get': value.status == 2 }">
                                <el-tooltip :content="`${value.itemName}`" placement="top" effect="dark">
                                    <img :src="value.itemImg" alt="" />
                                </el-tooltip>
                                <div v-if="value.status === 1" class="waiting-effect">
                                    <span>待领取</span>
                                </div>
                            </div>
                        </div>
                        <div class="below_Reward">
                            <div class="below_Reward_item Reward_item" v-for="value in getLinesByPosition('Bottom')"
                                :key="value.lineCode" @click="receiveAwardFun(value)"
                                :class="{ 'is-waiting': value.status === 1, 'is-get': value.status == 2 }">
                                <el-tooltip :content="`${value.itemName}`" placement="top" effect="dark">
                                    <img :src="value.itemImg" alt="" />
                                </el-tooltip>
                                <div v-if="value.status === 1" class="waiting-effect">
                                    <span>待领取</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 抽奖按钮 -->
                <div class="draw_buttons">
                    <div>
                        <img src="@/assets/imgs/OpeningCeremony/btn_draw_once.png" class="draw-btn"
                            @click="handleDraw('is-Lottery', 'one')" />
                        <p>本次消耗{{ OpeningCeremonyData.singleCost }}白金币</p>

                    </div>
                    <div>
                        <img src="@/assets/imgs/OpeningCeremony/btn_draw_ten.png" class="draw-btn"
                            @click="handleDraw('is-Lottery', 'ten')" />

                        <p>本次消耗{{ OpeningCeremonyData.tenCost }}白金币</p>
                    </div>

                </div>
            </div>

            <!-- 抽奖进度 -->
            <div class="Progress_section pubile">
                <div class="progress_item" v-for="(item, index) in OpeningCeremonyData.taskProgress" :key="index">
                    <!-- 标题 -->
                    <div class="progress_title" :class="'type_' + index">
                        <span class="title_icon" v-if="index == 0">🏆</span>
                        <span class="title_icon" v-else-if="index == 1">🏅</span>
                        <span class="title_icon" v-else-if="index == 2">🎁</span>
                        <span class="title_icon" v-else-if="index == 3">💥</span>
                        <span class="title_text">{{ item.title }}</span>
                    </div>

                    <!-- 进度信息 -->
                    <div class="progress_info">
                        <span class="current_text">当前进度
                            <template v-if="index == 3">
                                :{{ item.description }}
                            </template>

                        </span>

                        <span class="progress_num">
                            {{ item.progressText }}
                        </span>
                    </div>

                    <!-- 进度条 -->
                    <div class="progress_bar" :class="'bar_' + index">
                        <div class="progress_value" :style="{
                            width: getProgress(item.current, item.target)
                        }"></div>
                    </div>
                </div>
            </div>

            <!-- 获得等级数量  累计点亮 重复点亮  已点亮 -->
            <div class="s_reward_table pubile">
                <img src="@/assets/imgs/OpeningCeremony/bg_user_table.png" class="s_reward_table_bg" />
                <div class="s_reward_labels">
                    <span>未兑换</span>
                    <span>已兑换</span>
                </div>
                <div class="s_reward_table_items">
                    <div class="S">
                        <img src="@/assets/imgs/OpeningCeremony/btn_go_exchange.png" @click="openModal('S_Exchange', 'S级奖励兑换', {
                            sVoucherBalance: OpeningCeremonyData.sVoucherBalance,
                            sVoucherTotal: OpeningCeremonyData.sVoucherTotal,
                            sVoucherUsed: OpeningCeremonyData.sVoucherUsed,
                            data: OpeningCeremonyData.voucherShopList
                        })" />
                        <img src="@/assets/imgs/OpeningCeremony/btn_view.png" @click="S_SeeFun('S_See', 'S级奖励预览')" />
                    </div>
                    <div class="num">
                        <div>{{ OpeningCeremonyData.lightCount }}</div>
                        <div>{{ OpeningCeremonyData.repeatLightCount }}</div>
                        <div>{{ OpeningCeremonyData.lightedGrids?.length || 0 }}</div>
                    </div>
                </div>
            </div>

            <!-- 签到 -->
            <div class="sign_in_section pubile">
                <div class="title_sign">
                    <img src="@/assets/imgs/OpeningCeremony/title_sign.png" alt="" />
                </div>
                <div class="sign_in_wrapper">
                    <div class="Route">
                        <img class="map_track" src="@/assets/imgs/OpeningCeremony/map_track.png" alt="" />

                        <div class="sigin_Reward" v-for="(value, index) in OpeningCeremonyData.signList"
                            :key="value.dayNo" :style="{
                                left: SigndayList[index].x + '%',
                                top: SigndayList[index].y + '%',
                            }">
                            <div class="sigin_Reward_items" :class="[{ 'is-waiting': value.canSign }]"
                                v-for="rewards in value.rewards" @click="signInFun(value)">
                                <el-tooltip :content="`${rewards.name || rewards.itemName}X${rewards.quantity}`"
                                    placement="top" effect="dark">
                                    <img class="sigin_Reward_items_Reward" :src="rewards.itemImg" alt="" />
                                </el-tooltip>

                                <img v-if="value.signed == true" class="tag_claimed"
                                    src="@/assets/imgs/OpeningCeremony/tag_claimed.png" alt="" />
                                <img v-else-if="value.canMakeup == true" class="tag_retro"
                                    src="@/assets/imgs/OpeningCeremony/tag_retro.png" alt="" />
                                <img v-else-if="value.canSign !== true" class="tag_locked"
                                    src="@/assets/imgs/OpeningCeremony/tag_locked.png" alt="" />

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- 剩余使用货币 -->
            <!-- 剩余使用货币 -->
            <div class="xuyuanbi pubile">
                <!-- 第一行：标题栏 -->
                <div class="grid-row title-row">
                    <div class="grid-cell">
                        <span class="art-text">可使用的许愿币</span>
                    </div>
                    <div class="grid-cell border-left">
                        <span class="art-text">已使用的许愿币</span>
                    </div>
                    <div class="grid-cell border-left">
                        <span class="art-text">累计获得的许愿币</span>
                    </div>
                </div>

                <!-- 横向贯穿分割线 -->
                <div class="horizontal-line"></div>

                <!-- 第二行：数值栏 -->
                <div class="grid-row value-row">
                    <div class="grid-cell">
                        <span class="num-text">{{ OpeningCeremonyData.wishCoinBalance }}</span>
                    </div>
                    <div class="grid-cell border-left">
                        <span class="num-text">{{ OpeningCeremonyData.wishCoinUsed }}</span>
                    </div>
                    <div class="grid-cell border-left">
                        <span class="num-text">{{ OpeningCeremonyData.wishCoinTotal }}</span>
                    </div>
                </div>
            </div>

            <!-- 兑换专区 -->
            <div class="exchange_section pubile">
                <div class="title_exchange">
                    <img src="@/assets/imgs/OpeningCeremony/title_wish.png" alt="" />
                </div>
                <div class="Balance_exchange">
                    <div class="Balance_exchange_items">
                        <img src="@/assets/imgs/OpeningCeremony/title_currency_bg.png" alt="" />
                        <div class="Balance_exchange_item">许愿币：{{ OpeningCeremonyData.wishCoinBalance }}</div>
                    </div>
                </div>
                <!-- 兑换列表 -->
                <div class="exchange_section_list">
                    <div class="list_items" v-for="value in OpeningCeremonyData.shopList" :key="value.itemcodeId">
                        <div class="list_items_content">
                            <img class="list_items_bg" src="@/assets/imgs/OpeningCeremony/card_slot.png" alt="" />
                            <div class="list_item">
                                <div class="Currency">
                                    <img class="icon" src="@/assets/imgs/OpeningCeremony/icon.png" alt="" />
                                    <span> X {{ value.price }}</span>
                                </div>
                                <div class="img">
                                    <img class="Reward_img" :src="value.itemImg" alt="" />
                                    <img class="sex" v-if="value.sex == 1"
                                        src="@/assets/imgs/OpeningCeremony/userSex1.png" />
                                    <img class="sex" v-else-if="value.sex == 2"
                                        src="@/assets/imgs/OpeningCeremony/userSex2.png" />
                                    <img class="sex" v-else-if="value.sex == 3"
                                        src="@/assets/imgs/OpeningCeremony/userSex3.png" />
                                    <img class="sex" v-else src="@/assets/imgs/OpeningCeremony/userSex4.png" />
                                </div>
                                <div class="name">{{ value.itemName }}<template v-if="value.num > 1">x{{ value.num }}</template></div>
                            </div>
                        </div>
                        <div class="list_item_btn">
                            <img @click="exchangeSectionOpenModal(value)" v-if="value.status == 1"
                                src="@/assets/imgs/OpeningCeremony/btn_exchange.png" alt="" />
                            <img v-else src="@/assets/imgs/OpeningCeremony/btn_exchanged.png" alt="" />
                        </div>
                        <div class="item_number">
                            <template v-if="value.limitCount != 0">
                                ({{ value.buyCount ? value.buyCount : 0 }}/{{
                                    value.limitCount ? value.limitCount : 0
                                }})
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footerWX class="footerWX"></footerWX>

        <!-- 弹窗组件 -->

        <See v-if="showModal" :visible="showModal" :title="SeeTitle" :type="type" :SeeData="SeeData" @close="close"
            :drawBusy="drawBusy" :drawRound="drawRound" @confirmFun="confirmFun" />


        <!-- 新冰块点亮全屏特效：十连抽中有多个 repeat:false 时也只播放一次 -->
        <LightUpEffect :visible="showLightUpEffect" :results="lightUpResults" @complete="handleLightUpComplete" />

        <RewardPop v-model="showReward" :reward="reward" @close="handleRewardClose" />
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
import axios from "axios";
import Cookies from "js-cookie";
import popUp from "@/components/pop_up";
import See from "./component/see.vue";
import RewardPop from './component/RewardPop.vue'
import LightUpEffect from './component/LightUpEffect.vue'

import {
    getMemberInfoApi,
    getInfoApi,
    lightOnceApi,
    lightTenApi,
    makeupSignApi,
    signApi,
    exchangeShopApi,
    exchangeVoucherApi,
    voucherExchangeRecordsApi,
    claimLineRewardApi
} from './component/index.js'

export default {
    name: "OpeningCeremonyIndex",
    components: {
        headerWX,
        footerWX,
        popUp,
        See,
        RewardPop,
        LightUpEffect
    },
    data() {
        return {
            SigndayList: [
                { day: 1, x: 30, y: -15 },
                { day: 2, x: 62, y: -15 },
                { day: 3, x: 102, y: 7 },
                { day: 4, x: 62, y: 29 },
                { day: 5, x: 30, y: 31 },
                { day: 6, x: -14, y: 24 },
                { day: 7, x: 30, y: 53 },
                { day: 8, x: 63, y: 53 },
                { day: 9, x: 102, y: 53 },
                { day: 10, x: 30, y: 76 },
                { day: 11, x: 63, y: 76 },
                { day: 12, x: -14, y: 79 },
                { day: 13, x: 30, y: 100 },
                { day: 14, x: 63, y: 100 },
            ],
            showModal: false, //弹窗控制
            SeeTitle: '',//弹窗标题
            SeeData: null, // 弹窗数据
            type: '',//弹窗类型


            showReward: false,

            // 暴击奖励
            critReward: null,
            hasCritReward: false,

            // 新冰块点亮全屏特效
            showLightUpEffect: false,
            lightUpResults: [],

            // 当前抽奖流程，暴击动画结束后继续执行
            pendingLotteryResult: null,
            drawBusy: false,
            drawRound: 0,
            drawResultTimer: null,

            reward: {
                name: '传说级宝箱',
                image: 'https://download-wx.qtthtech.com/shop/item/1/341175.png',
                count: 1
            },

            loading: null,
            // 活动总数居
            OpeningCeremonyData: {},
            UserInfo: {},

        };
    },

    created() {


    },

    mounted() {
        this.init()
    },

    beforeDestroy() {
        clearTimeout(this.drawResultTimer)
        if (this.loading) this.loading.close()
    },

    computed: {

        getLinesByPosition() {
            return (position) => {
                const lineRewards = this.OpeningCeremonyData.lineRewards || [];
                if (position === 'Lift') {
                    return [...lineRewards.slice(0, 5), lineRewards[10]].filter(Boolean);
                }
                if (position === 'Bottom') {
                    return [lineRewards[11], ...lineRewards.slice(5, 10)].filter(Boolean);
                }
                return [];
            };
        },
    },

    methods: {

        openModal(type, tit, value) {
            this.type = type
            this.SeeTitle = tit
            this.SeeData = value
            this.showModal = true

        },
        //兑换打开弹窗
        exchangeSectionOpenModal(value) {
            this.openModal('exchangeSection', '兑换专区', value)
        },
        handleDraw(type, LotteryType) {
            if (this.drawBusy) return
            this.type = type
            this.SeeTitle = '是否确定抽奖'
            this.showModal = true
            this.SeeData = {
                LotteryType,
                lightedGrids: this.OpeningCeremonyData.lightedGrids
            }
            // 打开特效
            // this.handleDraw()
        },
        // 子组件通知
        confirmFun(msg) {
            console.log(msg);
            switch (msg.type) {
                case "is-Lottery":
                    const num = msg.data == 'one' ? 2 : 20
                    if (this.UserInfo.wallteInfo?.chargeMoney < num) {
                        this.$message.info('白金币不足，请先去充值吧！')
                        return
                    }
                    this.LotteryFun(msg.data)
                    break;
                case "Buqian":
                    if (this.UserInfo.wallteInfo?.chargeMoney < 20) {
                        this.$message.info('白金币不足，请先去充值吧！')
                        return
                    }
                    this.makeupSignFun(msg.data)
                    break;
                case "exchangeSection":
                    this.exchangeSectionFun(msg.data)
                    break
                case "S_Exchange":
                    console.log(msg, 'dd');
                    this.exchangeVoucherFun(msg.data)

                    break
                case "Lottery":
                    console.log(msg);
                    this.confirmFun({ type: 'is-Lottery', data: msg.data })
                default:
                    break;
            }
        },
        close() {
            if (this.drawBusy) return
            this.showModal = false
            this.SeeTitle = ''
        },
        // 抽奖接口
        LotteryFun(data) {
            if (this.drawBusy) return
            this.drawBusy = true
            const LotteryApi = data == 'one' ? lightOnceApi : lightTenApi

            this.loading = this.$loading({
                text: '抽奖中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            return LotteryApi().then(async (res) => {
                if (res.data.state != 200) {
                    this.drawBusy = false
                    this.$message.info(res.data.message || '抽奖未完成，请稍后再试');
                    return
                }

                const drawResults = res.data.data.drawResults || []

                console.log('========== 抽奖结果 ==========')
                console.log('drawResults:', drawResults)

                // 保存本次抽奖结果
                this.SeeData = drawResults

                // =====================================================
                // 1. 查找暴击奖励
                //
                // critTriggered === true 表示本次触发暴击
                // 十连抽即使出现多个 true，也只播放一次暴击动画
                // =====================================================
                const critResult = drawResults.find(item => {
                    return item && item.critTriggered === true
                })

                const critReward = critResult && critResult.critReward
                    ? critResult.critReward
                    : null

                console.log('暴击结果：', critResult)
                console.log('暴击奖励：', critReward)

                // =====================================================
                // 2. 查找新点亮冰块
                //
                // repeat === false 表示新冰块
                // 十连抽多个新冰块，只播放一次全屏点亮动画
                // =====================================================
                const newLightResults = drawResults.filter(item => {
                    return item && item.repeat === false
                })

                console.log('本次新点亮冰块：', newLightResults)

                // 刷新活动数据
                await this.init(false)

                // 保存后续流程
                this.pendingLotteryResult = {
                    drawResults,
                    newLightResults
                }

                // =====================================================
                // 3. 暴击奖励优先
                //
                // 有暴击 -> 先播放 RewardPop
                // RewardPop 关闭后，再继续新冰块/抽奖结果流程
                // =====================================================
                if (critReward) {
                    console.log('检测到暴击奖励，先播放暴击奖励动画')

                    this.critReward = critReward
                    this.hasCritReward = true

                    // 关闭普通抽奖弹窗
                    this.showModal = false

                    // 打开暴击奖励动画
                    this.OpenRewardPop(critReward)

                    return
                }

                // 没有暴击，直接进入正常流程
                this.continueLotteryResult()

            }).catch(err => {
                this.drawBusy = false
                this.$message.error(err.message);
            }).finally(() => {
                if (this.loading) {
                    this.loading.close()
                    this.loading = null
                }
            })
        },

        // =========================================================
        // 抽奖后续流程
        //
        // 1. 有新冰块 -> 播放点亮动画
        // 2. 没有新冰块 -> 直接显示抽奖结果
        //
        // 没有暴击时，LotteryFun 会直接调用。
        // 有暴击时，RewardPop 关闭后调用。
        // =========================================================
        continueLotteryResult() {
            const result = this.pendingLotteryResult

            if (!result) {
                return
            }

            const {
                drawResults,
                newLightResults
            } = result

            console.log('开始执行抽奖后续流程')
            console.log('新冰块数量：', newLightResults.length)

            // 有新冰块：播放全屏点亮动画
            if (newLightResults.length > 0) {
                this.lightUpResults = newLightResults
                this.showLightUpEffect = true
                this.showModal = false
                return
            }

            // 没有新冰块：直接显示抽奖结果
            this.showLotteryResult(drawResults)
        },

        showLotteryResult(drawResults) {
            this.type = 'Lottery'
            this.SeeTitle = '抽奖完成'
            this.SeeData = drawResults
            this.drawRound += 1
            this.showModal = true
            this.pendingLotteryResult = null
            clearTimeout(this.drawResultTimer)
            // 留出一轮奖励入场时间，避免玩家误以为没有响应而连续消费。
            this.drawResultTimer = setTimeout(() => {
                this.drawBusy = false
                this.drawResultTimer = null
            }, 1200)
        },

        //补签接口
        makeupSignFun(data) {
            this.loading = this.$loading({
                // lock: true,
                text: '补签中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            makeupSignApi({
                dayNo: data.dayNo,

            }).then((res) => {
                if (res.data.state == 200) {
                    this.$message.success(res.data.message);
                    this.init()
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
                this.close()
            })
        },
        // 兑换接口
        exchangeSectionFun(data) {
            this.loading = this.$loading({
                // lock: true,
                text: '商品兑换中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exchangeShopApi({
                buyNum: 1,
                goodsId: data.goodsId,
            }).then((res) => {
                if (res.data.state == 200) {
                    this.$message.success(res.data.message);
                    this.init()
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
                this.close()
            })
        },
        // 生成全局唯一的 requestNo
        generateRequestNo() {
            // 1. 如果支持原生的 randomUUID (HTTPS 或 localhost 环境)
            if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                return crypto.randomUUID();
            }

            // 2. 如果支持 getRandomValues (部分 HTTP 环境可能支持)
            if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                );
            }

            // 3. 终极兜底方案：Math.random 模拟 v4 UUID (全环境通用)
            return 'xxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        // S级 兑换
        exchangeVoucherFun(data) {
            this.loading = this.$loading({
                // lock: true,
                text: '商品兑换中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exchangeVoucherApi({
                requestId: this.generateRequestNo(),
                voucherGoodsId: data.goodsId
            }).then((res) => {
                if (res.data.state == 200) {
                    this.$message.success(res.data.message);
                    this.init()
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
            })
        },
        //S 查看
        S_SeeFun(type, tit) {
            this.loading = this.$loading({
                // lock: true,
                text: '查看中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            voucherExchangeRecordsApi({

            }).then((res) => {
                if (res.data.state == 200) {
                    this.openModal(type, tit, res.data.data.list)
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
            })
        },

        // =========================================================
        // 打开暴击奖励动画
        // =========================================================
        OpenRewardPop(data) {
            if (!data) {
                console.warn('OpenRewardPop：没有奖励数据')
                return
            }

            console.log('打开暴击奖励：', data)

            this.reward = {
                name: data.name || data.itemName || '特殊奖励',
                image: data.itemImg || data.itemImage || data.image || '',
                count: data.count || 1
            }

            this.showReward = true
        },

        // =========================================================
        // 暴击奖励动画关闭
        //
        // 如果这次抽奖还有新冰块：
        //      -> 播放冰块点亮动画
        //
        // 如果没有新冰块：
        //      -> 显示普通抽奖奖励
        // =========================================================
        handleRewardClose() {
            console.log('暴击奖励动画关闭')

            this.showReward = false
            this.hasCritReward = false
            this.critReward = null

            // 继续本次抽奖流程
            if (this.pendingLotteryResult) {
                this.continueLotteryResult()
            }
        },

        // =========================================================
        // 冰块点亮动画播放完成
        // =========================================================
        handleLightUpComplete() {
            console.log('冰块点亮动画结束')

            this.showLightUpEffect = false

            const result = this.pendingLotteryResult

            if (!result) {
                return
            }

            // 显示普通抽奖结果
            this.showLotteryResult(result.drawResults)
            this.lightUpResults = []
        },

        getProgress(current, total) {
            if (!total) {
                return '0%'
            }

            const value = (Number(current) / Number(total)) * 100

            return Math.min(Math.max(value, 0), 100) + '%'
        },

        // 签到
        signInFun(value) {

            if (value.canMakeup == true) {
                this.type = 'Buqian'
                this.SeeTitle = '补签'
                this.SeeData = value
                this.showModal = true
                return
            }
            if (value.canSign !== true) {
                return
            }
            this.loading = this.$loading({
                // lock: true,
                text: '签到中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            signApi().then((res) => {
                if (res.data.state == 200) {
                    this.$message.success(res.data.message);
                    this.init()
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
            })

        },
        // 领取线路
        receiveAwardFun(value) {
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            claimLineRewardApi({
                lineId: value.lineCode
            }).then((res) => {
                if (res.data.state == 200) {
                    this.$message.success(res.data.message);
                    this.init()
                } else {
                    this.$message.info(res.data.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading.close()
            })
        },


        // 初始化获取接口
        async init(showLoading = true) {
            const infoLoading = showLoading ? this.$loading({
                // lock: true,
                text: '获取数据中....',
                background: 'rgba(0, 0, 0, 0.7)'
            }) : null;
            await getInfoApi().then(res => {
                if (res.data.state == 200) {
                    this.OpeningCeremonyData = res.data.data
                } else {
                    this.$message.info('请刷新重试');
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                if (infoLoading) infoLoading.close()
            })

            await getMemberInfoApi().then((res) => {
                if (res.data.state == 200) {
                    this.UserInfo = res.data.data
                } else {
                    this.$message.info('请刷新重试');
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                if (infoLoading) infoLoading.close()
            })

        },
    },
};
</script>


<style>
body.modal-open {
    overflow: hidden !important;
}
</style>

<style lang="less" scoped>
@textShadow: -1px -1px 0 #0074e1ff, 1px -1px 0 #0074e1ff, -1px 1px 0 #0074e1ff,
    1px 1px 0 #0074e1ff;

.activity_container {
    min-width: 1200px;
    overflow: hidden;
    background: #a9d4fb url("~@/assets/imgs/OpeningCeremony/bg.png") no-repeat center top;
    // background-size: 100% auto;
    position: relative;

    /deep/ .footerWX {
        position: relative;
    }

    .main_content {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        padding-bottom: 60px;

        .pubile {
            width: 80%;
            margin: auto;
        }

        .light_pool_section {
            .tit {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .lift {
                    display: flex;
                    width: 28%;
                    justify-content: flex-start;
                    position: relative;
                    z-index: 30;
                    gap: 20px;

                    >img {
                        width: 30%;
                        max-width: 80px;
                        cursor: pointer;
                    }
                }

                .tit_bg {
                    width: 28%;
                    max-width: 300px;
                }

                .right {
                    position: relative;
                    width: 22%;
                    max-width: 260px;

                    >img {
                        width: 100%;
                        max-width: 260px;
                    }

                    .coin {
                        width: 80%;
                        text-align: center;
                        position: absolute;
                        top: 55%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        gap: 20px;
                        align-items: center;
                        justify-content: center;

                        .coin_num {
                            font-size: 1.3em;
                            font-weight: 700;
                            color: #fff;
                            text-shadow: @textShadow;
                        }

                        .coin_exchange {
                            font-size: 14px;
                            padding: 5px 10px;
                            border: 1px solid #0074e1;
                            background-color: #0074e160;
                            color: #fff;
                            border-radius: 5px;
                            text-shadow: -1px -1px 0 #d22190, 1px -1px 0 #d22190,
                                -1px 1px 0 #d22190, 1px 1px 0 #d22190;
                            cursor: pointer;
                        }
                    }
                }
            }

            .pool_grid_wrapper {
                margin-top: 30px;
                position: relative;
                padding-bottom: 180px;

                .wrapper_Content {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px 23px;

                    .wrapper_Content_item {
                        width: 18%;

                        >img {
                            width: 100%;
                        }
                    }
                }

                // 右边奖励
                .right_Reward {
                    position: absolute;
                    right: -160px;
                    top: 25px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    gap: 76px;

                    .right_Reward_item {
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        margin: auto;

                        >img {
                            max-width: 90%;
                            max-height: 90%;
                        }
                    }
                }

                // 下边奖励
                .below_Reward {
                    position: absolute;
                    bottom: 0;
                    right: 20px;
                    display: flex;
                    gap: 75px;

                    .below_Reward_item {
                        align-items: center;
                        position: relative;

                        >img {
                            max-width: 90%;
                            max-height: 90%;
                        }
                    }
                }

                .Reward_item {
                    display: flex;
                    width: 120px;
                    height: 120px;
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: 0px 2px 4px 0px #5c8add;
                    border-radius: 10px 10px 10px 10px;
                    border: 1px solid #5c8add;
                }

                //已领取
                .is-get {
                    position: relative;
                    background: linear-gradient(135deg, #e8e8e8 0%, #d5d5d5 100%);
                    border: 1px solid #c8c8c8;
                    cursor: not-allowed;
                    transition: all 0.3s ease;

                    // 图片置灰 + 降低透明度
                    >img {
                        filter: grayscale(100%) brightness(0.85);
                        -webkit-filter: grayscale(100%) brightness(0.85);
                        opacity: 0.6;
                    }

                    // 右上角"已领取"角标
                    &::after {
                        content: '已领取';
                        position: absolute;
                        top: 0;
                        right: 0;
                        padding: 2px 8px;
                        font-size: 10px;
                        color: #ffffff;
                        background: linear-gradient(135deg, #9e9e9e, #757575);
                        border-radius: 0 0 0 8px;
                        letter-spacing: 1px;
                        line-height: 1.6;
                    }

                    // 整体遮罩层（可选，让整体更"沉"）
                    &::before {
                        content: '';
                        position: absolute;
                        inset: 0;
                        background: rgba(255, 255, 255, 0.25);
                        border-radius: inherit;
                        pointer-events: none;
                    }
                }

                //    待领取状态 

                .is-waiting {

                    /* 原本蓝色边框变成金色 */
                    border-color: #ffc94d;

                    /* 金色呼吸光 */
                    box-shadow:
                        0 0 4px rgba(255, 201, 77, 0.9),
                        0 0 12px rgba(255, 201, 77, 0.7),
                        0 0 24px rgba(255, 188, 45, 0.35);

                    animation: waitingBreath 1.8s ease-in-out infinite;


                    //    奖励图片 

                    >img {
                        position: relative;
                        z-index: 2;

                        filter:
                            drop-shadow(0 0 4px rgba(255, 211, 91, 0.8)) drop-shadow(0 0 10px rgba(255, 190, 40, 0.4));

                        animation: rewardFloat 1.8s ease-in-out infinite;
                    }


                    //    唯一特效 DIV 

                    .waiting-effect {
                        position: absolute;

                        left: 0;
                        top: 0;

                        width: 100%;
                        height: 100%;

                        border-radius: 10px;

                        z-index: 5;

                        pointer-events: none;

                        overflow: visible;


                        //    外边框 

                        &::before {
                            content: "";

                            position: absolute;

                            left: -2px;
                            top: -2px;

                            width: calc(100% + 4px);
                            height: calc(100% + 4px);

                            border-radius: 11px;

                            border: 2px solid #ffd45c;

                            box-sizing: border-box;

                            box-shadow:
                                0 0 5px rgba(255, 215, 91, 0.9),
                                0 0 14px rgba(255, 195, 52, 0.65),
                                0 0 25px rgba(255, 183, 35, 0.3);

                            animation: borderBreath 1.5s ease-in-out infinite;
                        }


                        //    中间光晕

                        &::after {
                            content: "";

                            position: absolute;

                            left: 50%;
                            top: 50%;

                            width: 75%;
                            height: 75%;

                            transform: translate(-50%, -50%);

                            border-radius: 50%;

                            background: radial-gradient(circle,
                                    rgba(255, 218, 93, 0.35) 0%,
                                    rgba(255, 200, 55, 0.18) 35%,
                                    rgba(255, 200, 55, 0) 72%);

                            filter: blur(7px);

                            animation: centerGlow 1.6s ease-in-out infinite;
                        }


                        //    待领取标签

                        span {
                            position: absolute;

                            left: 50%;
                            top: -18px;

                            transform: translateX(-50%);

                            z-index: 10;

                            height: 25px;

                            padding: 0 11px;

                            display: flex;

                            align-items: center;

                            justify-content: center;

                            box-sizing: border-box;

                            border-radius: 14px;

                            white-space: nowrap;

                            color: #fff;

                            font-size: 12px;

                            font-weight: bold;

                            line-height: 25px;

                            letter-spacing: 1px;

                            background: linear-gradient(135deg,
                                    #ffe46e 0%,
                                    #ffc43e 50%,
                                    #ff9f27 100%);

                            border: 1px solid rgba(255, 255, 255, 0.95);

                            box-shadow:
                                0 2px 6px rgba(255, 159, 39, 0.4),
                                0 0 10px rgba(255, 197, 62, 0.45);

                            text-shadow:
                                0 1px 2px rgba(130, 70, 0, 0.35);

                            animation: tagFloat 1.8s ease-in-out infinite;


                            /* 小圆点 */

                            &::before {
                                content: "";

                                width: 5px;
                                height: 5px;

                                margin-right: 5px;

                                border-radius: 50%;

                                background: #fff;

                                box-shadow:
                                    0 0 4px #fff,
                                    0 0 8px #ffe36c;

                                animation: dotBlink 0.8s ease-in-out infinite;
                            }


                            /* 下方小三角 */

                            &::after {
                                content: "";

                                position: absolute;

                                left: 50%;
                                bottom: -5px;

                                transform: translateX(-50%);

                                width: 0;
                                height: 0;

                                border-left: 5px solid transparent;
                                border-right: 5px solid transparent;
                                border-top: 5px solid #ffb52f;
                            }
                        }
                    }
                }


                //     整体呼吸 

                @keyframes waitingBreath {

                    0% {
                        box-shadow:
                            0 0 4px rgba(255, 201, 77, 0.6),
                            0 0 10px rgba(255, 201, 77, 0.35);
                    }

                    50% {
                        box-shadow:
                            0 0 7px rgba(255, 201, 77, 1),
                            0 0 18px rgba(255, 201, 77, 0.75),
                            0 0 32px rgba(255, 188, 45, 0.4);
                    }

                    100% {
                        box-shadow:
                            0 0 4px rgba(255, 201, 77, 0.6),
                            0 0 10px rgba(255, 201, 77, 0.35);
                    }
                }


                //    边框呼吸 

                @keyframes borderBreath {

                    0% {
                        opacity: 0.55;
                    }

                    50% {
                        opacity: 1;
                        filter: brightness(1.25);
                    }

                    100% {
                        opacity: 0.55;
                    }
                }


                //    中间光晕 

                @keyframes centerGlow {

                    0% {
                        opacity: 0.3;

                        transform:
                            translate(-50%, -50%) scale(0.8);
                    }

                    50% {
                        opacity: 0.8;

                        transform:
                            translate(-50%, -50%) scale(1.15);
                    }

                    100% {
                        opacity: 0.3;

                        transform:
                            translate(-50%, -50%) scale(0.8);
                    }
                }


                //奖励上下浮动

                @keyframes rewardFloat {

                    0% {
                        transform: translateY(0) scale(1);
                    }

                    50% {
                        transform: translateY(-3px) scale(1.035);
                    }

                    100% {
                        transform: translateY(0) scale(1);
                    }
                }


                //  标签浮动 

                @keyframes tagFloat {

                    0% {
                        transform:
                            translateX(-50%) translateY(0);
                    }

                    50% {
                        transform:
                            translateX(-50%) translateY(-3px);
                    }

                    100% {
                        transform:
                            translateX(-50%) translateY(0);
                    }
                }

                //    标签小圆点

                @keyframes dotBlink {

                    0% {
                        opacity: 0.4;
                        transform: scale(0.8);
                    }

                    50% {
                        opacity: 1;
                        transform: scale(1.25);
                    }

                    100% {
                        opacity: 0.4;
                        transform: scale(0.8);
                    }
                }
            }

            .draw_buttons {
                display: flex;
                justify-content: center;
                gap: 50px;
                margin: 80px 0 50px;

                >div {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 20px;

                    /* 按钮基础与呼吸动效 */
                    .draw-btn {
                        cursor: pointer;

                        user-select: none;
                        -webkit-user-drag: none;
                    }

                    /* 悬停（Hover）效果：放大、发光、停止呼吸防止抖动 */
                    .draw-btn:hover {
                        animation-play-state: paused;
                        transform: scale(1.08);
                        filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.8)) brightness(1.15);
                    }

                    /* 点击（Active）效果：瞬间缩小、向下位移，模拟真实的物理按压感 */
                    .draw-btn:active {
                        transform: scale(0.92) translateY(4px);
                        filter: brightness(0.9);
                    }

                    p {
                        color: #fff;
                        text-shadow: @textShadow;
                        letter-spacing: 3px;
                    }
                }

            }
        }

        .Progress_section {
            box-sizing: border-box;

            width: 80%;
            margin: auto;

            padding: 32px 76px 36px;

            background: #fff;

            border-radius: 32px;

            /* 外层淡淡的粉色光晕 */
            box-shadow: 0 0 35px #ffaac39c;

            /* 防止内容溢出 */
            overflow: hidden;

            .progress_item {
                width: 100%;

                margin-bottom: 26px;

                &:last-child {
                    margin-bottom: 0;
                }
            }


            .progress_title {
                height: 38px;

                display: flex;
                align-items: center;

                width: max-content;

                font-size: 26px;
                font-weight: 800;

                line-height: 38px;

                letter-spacing: 2px;

                white-space: nowrap;

                .title_icon {
                    display: inline-flex;

                    align-items: center;
                    justify-content: center;

                    width: 28px;
                    height: 28px;

                    margin-right: 8px;

                    font-size: 24px;

                    line-height: 1;
                }

                .title_text {
                    display: inline-block;
                    font-size: 18px;
                    font-weight: 700;
                }
            }




            .type_0 {
                color: #f2a72f;

                text-shadow: 0 1px 0 rgba(255, 220, 130, .45);
            }




            .type_1 {
                color: #8759d0;

                text-shadow: 0 1px 0 rgba(190, 150, 255, .3);
            }



            .type_2 {
                color: #1976d2;

                text-shadow: 0 1px 0 rgba(100, 170, 255, .25);
            }



            .type_3 {
                color: #d85b5b;

                text-shadow: 0 1px 0 rgba(255, 130, 130, .25);
            }


            .progress_info {
                width: 100%;

                height: 24px;

                margin-top: 0;

                display: flex;

                align-items: center;

                justify-content: space-between;

                box-sizing: border-box;

                .current_text {
                    font-size: 16px;

                    font-weight: 500;

                    color: #2691dc;

                    line-height: 24px;
                }

                .progress_num {
                    font-size: 15px;

                    font-weight: 500;

                    color: #2691dc;

                    line-height: 24px;
                }
            }


            .progress_bar {
                position: relative;

                width: 100%;

                height: 18px;

                margin-top: 1px;

                box-sizing: border-box;

                border-radius: 12px;

                background: #fff;

                overflow: hidden;

                .progress_value {
                    position: absolute;

                    left: 0;
                    top: 0;

                    height: 100%;

                    border-radius: 12px;

                    transition: width .5s ease;
                }
            }



            .bar_0 {
                border: 1px solid #f3b84e;

                .progress_value {
                    background: #f3b348;
                }
            }



            .bar_1 {
                border: 1px solid #955bd9;

                .progress_value {
                    background: #955bd9;
                }
            }



            .bar_2 {
                border: 1px solid #4c8cdd;

                .progress_value {
                    background: #4b8bdc;
                }
            }


            .bar_3 {
                border: 1px solid #e05f61;

                .progress_value {
                    background: #df6262;
                }
            }
        }

        // 获得等级数量  累计点亮 重复点亮  已点亮
        .s_reward_table {
            position: relative;
            margin-top: 80px;

            .s_reward_table_bg {
                width: 100%;
            }

            .s_reward_labels {
                position: absolute;
                top: 41%;
                left: 3.8%;
                width: 30.8%;
                height: 13%;
                display: flex;
                gap: 2px;
                pointer-events: none;

                span {
                    flex: 1;
                    background: #fff;
                    color: #5b89e5;
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

            .s_reward_table_items {
                position: absolute;
                top: 39%;
                left: 50%;
                transform: translateX(-50%);
                width: 93%;
                height: 46%;
                display: flex;

                .S {
                    width: 33.5%;
                    display: flex;
                    justify-content: space-around;
                    align-items: flex-end;

                    >img {
                        max-width: 80px;
                        cursor: pointer;
                    }
                }

                .num {
                    flex: 1;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;

                    >div {
                        text-shadow: @textShadow;
                        color: #ffffff;
                        font-size: 20px;
                        font-weight: 700;
                    }
                }
            }
        }

        // 签到
        .sign_in_section {
            margin-top: 50px;

            .title_sign {
                text-align: center;
            }

            .sign_in_wrapper {
                /* 纯白色背景 */
                background: #ffffff;
                /* 大圆角，匹配图中的圆润边角 */
                border-radius: 24px;
                /* 柔和淡阴影，营造轻量悬浮感 */
                box-shadow: 10px -11px 25px 8px rgba(255, 182, 193, 0.4),
                    0 0 0 1px rgba(255, 150, 175, 0.3);
                padding: 120px 0;
                /* 盒模型：防止内边距撑宽容器 */
                box-sizing: border-box;
                /* 可选：宽度控制+居中 */
                width: 100%;
                margin: 30px 0;

                .Route {
                    width: 70%;
                    margin: auto;
                    position: relative;

                    .map_track {
                        width: 100%;
                    }

                    .sigin_Reward {
                        position: absolute;
                        display: flex;
                        gap: 10px;

                        .sigin_Reward_items {
                            width: 80px;
                            height: 80px;
                            box-shadow: 0px 2px 4px 0px rgba(160, 66, 255, 0.2);
                            border-radius: 10px 10px 10px 10px;
                            border: 1px solid #5c8add;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;

                            .sigin_Reward_items_Reward {
                                max-width: 100%;
                            }

                            .tag_locked {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }

                            .tag_claimed {
                                position: absolute;
                                bottom: 0%;
                                right: 0%;
                            }

                            .tag_retro {
                                position: absolute;
                                bottom: 0%;
                                right: 0%;
                            }
                        }

                        // 签到项
                        .is-waiting {

                            /* 原本蓝色边框变成金色 */
                            border-color: #ffc94d;

                            /* 金色呼吸光 */
                            box-shadow:
                                0 0 4px rgba(255, 201, 77, 0.9),
                                0 0 12px rgba(255, 201, 77, 0.7),
                                0 0 24px rgba(255, 188, 45, 0.35);

                            animation: waitingBreath 1.8s ease-in-out infinite;


                            //    奖励图片 

                            >img {
                                position: relative;
                                z-index: 2;

                                filter:
                                    drop-shadow(0 0 4px rgba(255, 211, 91, 0.8)) drop-shadow(0 0 10px rgba(255, 190, 40, 0.4));

                                animation: rewardFloat 1.8s ease-in-out infinite;
                            }


                            //    唯一特效 DIV 

                            .waiting-effect {
                                position: absolute;

                                left: 0;
                                top: 0;

                                width: 100%;
                                height: 100%;

                                border-radius: 10px;

                                z-index: 5;

                                pointer-events: none;

                                overflow: visible;


                                //    外边框 

                                &::before {
                                    content: "";

                                    position: absolute;

                                    left: -2px;
                                    top: -2px;

                                    width: calc(100% + 4px);
                                    height: calc(100% + 4px);

                                    border-radius: 11px;

                                    border: 2px solid #ffd45c;

                                    box-sizing: border-box;

                                    box-shadow:
                                        0 0 5px rgba(255, 215, 91, 0.9),
                                        0 0 14px rgba(255, 195, 52, 0.65),
                                        0 0 25px rgba(255, 183, 35, 0.3);

                                    animation: borderBreath 1.5s ease-in-out infinite;
                                }

                              
                            }
                              @keyframes borderBreath {

                                    0% {
                                        opacity: 0.55;
                                    }

                                    50% {
                                        opacity: 1;
                                        filter: brightness(1.25);
                                    }

                                    100% {
                                        opacity: 0.55;
                                    }
                                }

                        }

                        &:nth-of-type(12),
                        &:nth-of-type(6) {
                            flex-direction: column;
                        }
                    }
                }
            }
        }

        //剩余使用货币
        .xuyuanbi {
            margin-top: 50px;
            position: relative;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            padding: 12px 0;

            // 1. 原图背景与双重边框
            background: #fff;
            border: 3px solid #ffffff; // 亮白外边框
            outline: 1px solid #b2d2ff; // 最外层细框
            border-radius: 24px;
            box-shadow:
                0 8px 20px rgba(100, 150, 230, 0.35),
                inset 0 0 10px rgba(255, 255, 255, 0.8); // 内部高光

            // 行容器
            .grid-row {
                display: flex;
                width: 100%;
                align-items: center;

                &.title-row {
                    height: 48px;
                }

                &.value-row {
                    height: 52px;
                }
            }

            // 网格单元格
            .grid-cell {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;

                // 竖向分割线（原图精准颜色）
                &.border-left {
                    border-left: 1.5px solid #4893ff;
                }
            }

            // 2. 贯穿左右的横向分割线
            .horizontal-line {
                width: 100%;
                height: 1.5px;
                background-color: #4893ff;
            }

            // 3. 标题艺术字（核心 1:1 还原：白边 + 蓝色多重描边阴影）
            .art-text {
                font-size: 16px;
                font-weight: 900;
                color: #3b88fd;
                letter-spacing: 0.5px;
                // 模拟原图 3D 厚描边与外发光效果
                text-shadow:
                    -1.5px -1.5px 0 #fff,
                    1.5px -1.5px 0 #fff,
                    -1.5px 1.5px 0 #fff,
                    1.5px 1.5px 0 #fff,
                    -2px 0 0 #fff,
                    2px 0 0 #fff,
                    0 -2px 0 #fff,
                    0 2px 0 #fff,
                    0 2px 4px rgba(35, 100, 220, 0.6);
            }

            // 4. 下方数字样式
            .num-text {
                font-size: 20px;
                font-weight: bold;
                color: #2b70e4;
                text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
            }
        }

        // 兑换专区
        .exchange_section {
            margin-top: 50px;

            .title_exchange {
                text-align: center;
            }

            .Balance_exchange {
                margin: 20px auto;
                display: flex;
                justify-content: center;

                .Balance_exchange_items {
                    display: inline-block;
                    position: relative;

                    .Balance_exchange_item {
                        width: 80%;
                        height: 80%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 700;
                        color: #fff;
                        text-shadow: @textShadow;
                    }
                }
            }

            // 兑换列表
            .exchange_section_list {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                gap: 40px 20px;

                .list_items {
                    width: 20%;

                    .list_items_content {
                        width: 100%;
                        position: relative;

                        .list_items_bg {
                            width: 100%;
                        }

                        .list_item {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 91%;
                            height: 94%;
                            transform: translate(-50%, -50%);
                            display: flex;
                            flex-direction: column;

                            .Currency {
                                width: 100%;
                                height: 20%;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .icon {
                                    height: 80%;
                                }

                                span {
                                    color: #fff;
                                    text-shadow: @textShadow;
                                    font-size: 18px;
                                }
                            }

                            .img {
                                width: 100%;
                                height: 60%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                position: relative;

                                .Reward_img {
                                    max-width: 100%;
                                    max-height: 90%;
                                }

                                .sex {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                }
                            }

                            .name {
                                width: 100%;
                                height: 20%;
                                color: #0074e1;
                                text-shadow: none;
                                font-weight: 700;
                                font-size: 16px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                letter-spacing: 0.2em;
                            }
                        }
                    }

                    .list_item_btn {
                        width: 100%;
                        text-align: center;

                        >img {
                            width: 80%;
                        }
                    }

                    .item_number {
                        text-align: center;
                        // margin-bottom: 50px;
                        color: rgb(255, 255, 255);
                        font-size: 20px;
                        text-shadow: -1px -1px 0 #d22190, 1px -1px 0 #d22190,
                            -1px 1px 0 #d22190, 1px 1px 0 #d22190;
                    }
                }
            }
        }
    }
}
</style>
